import {
  FETCH_PAYMENT_PROOFS_REQUEST,
  FETCH_PAYMENT_PROOFS_SUCCESS,
  FETCH_PAYMENT_PROOFS_FAILURE,
  UPDATE_PAYMENT_PROOF_STATUS_REQUEST,
  UPDATE_PAYMENT_PROOF_STATUS_SUCCESS,
  UPDATE_PAYMENT_PROOF_STATUS_FAILURE,
} from "./types";

import { fetchPaymentProofs, updatePaymentProofStatus } from "../../services/paymentProofService";

// Fetch Payment Proofs
export const fetchPaymentProofsRequest = () => ({ type: FETCH_PAYMENT_PROOFS_REQUEST });
export const fetchPaymentProofsSuccess = (data) => ({ type: FETCH_PAYMENT_PROOFS_SUCCESS, payload: data });
export const fetchPaymentProofsFailure = (error) => ({ type: FETCH_PAYMENT_PROOFS_FAILURE, payload: error });

export const fetchPaymentProofsAction = (page = 1, size = 10) => async (dispatch) => {
  dispatch(fetchPaymentProofsRequest());
  try {
    const response = await fetchPaymentProofs(page, size);
    if (response.success) {
      dispatch(fetchPaymentProofsSuccess(response.data));
    } else {
      dispatch(fetchPaymentProofsFailure(response.error));
    }
  } catch (error) {
    dispatch(fetchPaymentProofsFailure(error.message));
  }
};

// Update Payment Proof Status
export const updatePaymentProofStatusRequest = () => ({ type: UPDATE_PAYMENT_PROOF_STATUS_REQUEST });
export const updatePaymentProofStatusSuccess = (data) => ({ type: UPDATE_PAYMENT_PROOF_STATUS_SUCCESS, payload: data });
export const updatePaymentProofStatusFailure = (error) => ({ type: UPDATE_PAYMENT_PROOF_STATUS_FAILURE, payload: error });

export const updatePaymentProofStatusAction = (proofId, status) => async (dispatch) => {
  dispatch(updatePaymentProofStatusRequest());
  try {
    const response = await updatePaymentProofStatus(proofId, status);
    if (response.success) {
      dispatch(updatePaymentProofStatusSuccess(response.data));
      
      dispatch(fetchPaymentProofsAction());
    } else {
      dispatch(updatePaymentProofStatusFailure(response.error));
    }
  } catch (error) {
    dispatch(updatePaymentProofStatusFailure(error.message));
  }
};
